import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import { getFbTrackingPayload } from "../../../utils/fbTracking";
import * as actions from "./actions";

function* fetchBachGroups() {
  try {
    const result = yield call(AxiosCall, `/bachflowers/get_groups/`);
    yield put(actions.fetchBachGroupsSuccess(result.data.groups, result.data.available));
  } catch (e) {
    yield put(actions.fetchBachGroupsFailure(e));
  }
}

function* fetchQuestionnaire(action) {
  try {
    const result = yield call(AxiosPost, `/bachflowers/get_questionnaire/`, action.payload);
    const { results } = result.data;
    yield put(actions.fetchQuestionnaireSuccess(results));
  } catch (e) {
    yield put(actions.fetchQuestionnaireFailure(e));
  }
}

function* submitQuestionnaire(action) {
  try {
    const result = yield call(AxiosPost, `/bachflowers/submit_questionnaire/`, action.payload);
    const reading = result.data.results?.at(0);
    if (!reading) {
      throw new Error("Error al procesar el cuestionario");
    }
    yield put(actions.submitQuestionnaireSuccess(reading));
  } catch (e) {
    yield put(actions.submitQuestionnaireFailure(e));
  }
}

function* captureBachLead(action) {
  try {
    yield call(AxiosPost, `/marketing/capture_lead/`, action.payload);
    yield put(actions.captureLeadSuccess());
  } catch (e) {
    yield put(actions.captureLeadFailure(e));
  }
}

function* fetchBachAllFlowers() {
  try {
    const result = yield call(AxiosCall, `/bachflowers/get_flowers/`);
    const { results } = result.data;
    yield put(actions.fetchBachAllFlowersSuccess(results));
  } catch (e) {
    yield put(actions.fetchBachAllFlowersFailure(e));
  }
}

function* setBachReadingLike(action) {
  try {
    yield call(AxiosPost, `/bachflowers/set_reading_like/`, action.payload);
    yield put(actions.setBachReadingLikeSuccess());
  } catch (e) {
    yield put(actions.setBachReadingLikeFailure(e));
  }
}

function* createBachCheckout(action) {
  try {
    const result = yield call(AxiosPost, `/bachflowers/create_checkout/`, { ...action.payload, ...getFbTrackingPayload() });
    const { checkout_url } = result.data;
    yield put(actions.createBachCheckoutSuccess(checkout_url));
    window.location.href = checkout_url;
  } catch (e) {
    yield put(actions.createBachCheckoutFailure(e));
  }
}

function* createBachPaypalOrder(action) {
  try {
    const result = yield call(AxiosPost, `/bachflowers/create_paypal_order/`, { ...action.payload, ...getFbTrackingPayload() });
    const { approve_url } = result.data;
    yield put(actions.createBachPaypalOrderSuccess(approve_url));
    window.location.href = approve_url;
  } catch (e) {
    yield put(actions.createBachPaypalOrderFailure(e));
  }
}

function* verifyBachPaypalPurchase(action) {
  try {
    const result = yield call(AxiosPost, `/bachflowers/verify_paypal_purchase/`, { ...action.payload, ...getFbTrackingPayload() });
    if (result.data.email) {
      localStorage.setItem('bach_purchase_email', result.data.email);
    }
    yield put(actions.verifyBachPaypalPurchaseSuccess(result.data.reading));
  } catch (e) {
    yield put(actions.verifyBachPaypalPurchaseFailure(e));
  }
}

function* verifyBachPurchase(action) {
  try {
    const result = yield call(AxiosPost, `/bachflowers/verify_purchase/`, action.payload);
    // Save email in localStorage so future readings auto-check access
    if (result.data.email) {
      localStorage.setItem('bach_purchase_email', result.data.email);
    }
    yield put(actions.verifyBachPurchaseSuccess(result.data.reading));
  } catch (e) {
    yield put(actions.verifyBachPurchaseFailure(e));
  }
}

function* checkBachAccess(action) {
  try {
    const result = yield call(AxiosPost, `/bachflowers/check_access/`, action.payload);
    yield put(actions.checkBachAccessSuccess(result.data.has_access, result.data.expires_at));
  } catch (e) {
    yield put(actions.checkBachAccessFailure(e));
  }
}

export default function* bachFlowersSaga() {
  yield all([
    takeLatest(actions.FETCH_BACH_GROUPS_REQUEST, fetchBachGroups),
    takeLatest(actions.FETCH_QUESTIONNAIRE_REQUEST, fetchQuestionnaire),
    takeLatest(actions.FETCH_BACH_ALL_FLOWERS_REQUEST, fetchBachAllFlowers),
    takeLatest(actions.SUBMIT_QUESTIONNAIRE_REQUEST, submitQuestionnaire),
    takeLatest(actions.SET_BACH_READING_LIKE_REQUEST, setBachReadingLike),
    takeLatest(actions.CAPTURE_BACH_LEAD_REQUEST, captureBachLead),
    takeLatest(actions.CREATE_BACH_CHECKOUT_REQUEST, createBachCheckout),
    takeLatest(actions.CREATE_BACH_PAYPAL_ORDER_REQUEST, createBachPaypalOrder),
    takeLatest(actions.VERIFY_BACH_PURCHASE_REQUEST, verifyBachPurchase),
    takeLatest(actions.VERIFY_BACH_PAYPAL_PURCHASE_REQUEST, verifyBachPaypalPurchase),
    takeLatest(actions.CHECK_BACH_ACCESS_REQUEST, checkBachAccess),
  ]);
}
